import * as ngCore from '@angular/core'

import * as state from '../../../../../../state'

import * as orgChart from './org-chart'

/**
 * Page in Summit used to edit your org chart
 */
@ngCore.Component({
  imports: [orgChart.Component],
  selector: 'atn-summit-organization-page',
  standalone: true,
  styleUrls: ['./component.scss'],
  templateUrl: './component.html',
})
export class Component {
  /** @see {@link state.summit.orgChart.Feature} */
  public readonly orgChartFeature = ngCore.inject(state.summit.orgChart.Feature)
}
